import React from "react";
import { ReactComponent as VerifiedCheck } from "../../../assets/images/Verified_Check.svg";
import { ReactComponent as WarningTriangle } from "../../../assets/icons/WarningTriangle.svg";
import profile from "../../../assets/images/profile.svg";

export const VerifiedByTrevex = ({ status, logo=false }) => {
  // TIP-486 (MV Stage 1): the secondary-sources disclaimer is now keyed as
  // 'secondary' to match the backend vocabulary. 'warning' is kept as an alias
  // so existing call sites keep working until the client-side status logic is
  // migrated to consume the backend profile_status in a later stage.
  const secondarySourcesConfig = {
    bgClass: "bg-highWarning",
    icon: <WarningTriangle />,
    text: "Information on this profile is compiled from secondary data sources.",
  };

  const statusConfig = {
    verified: {
      bgClass: "bg-gradient-to-r from-verifies to-verified",
      icon: <VerifiedCheck />,
      text: "An authorized representative manages this company profile, and it has been verified by TREVEX.",
    },
    // TIP-486 (MV Stage 1): active TREVEX member, not (yet) verified. Mirrors the
    // 'claimed' banner styling but states the company is a member of TREVEX.
    member: {
      bgClass: "bg-claimed",
      icon: <VerifiedCheck />,
      text: "An authorized representative manages this company profile, and this company is a member of TREVEX.",
    },
    claimed: {
      bgClass: "bg-claimed",
      icon: <VerifiedCheck />,
      text: "An authorized representative has accessed and actively manages this company profile.",
    },
    secondary: secondarySourcesConfig,
    warning: secondarySourcesConfig,
    listing: {
      bgClass: "",
      inlineStyle: { backgroundColor: "darkgrey" },
      icon: <WarningTriangle />,
      text: "This profile is a directory-based listing featuring globally-sourced information.",
    },
  };

  const config = statusConfig[status];

  if (!config) return null; // Return nothing if status is not recognized

  return (
      <div
        className={`${config.bgClass} text-slate font-semibold py-2 px-0 relative flex items-center justify-end sm:justify-center`}
        style={config.inlineStyle}
      >
        <div className="w-[calc(100%-120px)] sm:w-full flex items-center justify-center gap-1">
        <div className="hidden sm:block max-w-[21px]">{config.icon}</div>
        <p className="uppercase text-slate font-semibold text-[9px] sm:text-f14 text-left">
          {config.text}
        </p>
        </div>
        {<img class="block sm:hidden absolute top-[-24px] left-[14px] rounded-[4px] border-[4px] border-[#DBDBDB] sm:h-auto h-[90px] sm:w-auto w-[90px]" src={logo ? logo : profile} alt="Company Logo" />}
      </div>
  );
};

